/**
 * Actions types for loading process
 */
export const UPDATE_LOADING = 'UPDATE_LOADING';

/**
 * Actions types for procesing visualition information
 * Is information about coordinates, zoom, boundaries,etc
 */
export const GET_GENERAL_INFO_INIT = 'GET_GENERAL_INFO_INIT';
export const GET_GENERAL_INFO_SUCCESS = 'GET_GENERAL_INFO_SUCCESS';
export const GET_GENERAL_INFO_FAILURE = 'GET_GENERAL_INFO_FAILURE';

/**
 * Actions types for procesing client information
 * Link, name, etc.
 */
export const GET_CLIENT_INFO_INIT = 'GET_CLIENT_INFO_INIT';
export const GET_CLIENT_INFO_SUCCESS = 'GET_CLIENT_INFO_SUCCESS';
export const GET_CLIENT_INFO_FAILURE = 'GET_CLIENT_INFO_FAILURE';

/**
 * Actions types for procesing crash data
 * All the incidents according with the selected filters, eachone has coordinates, id etc
 */
export const GET_FILTERED_DATA_INIT = 'GET_FILTERED_DATA_INIT';
export const GET_FILTERED_SUCCESS = 'GET_FILTERED_SUCCESS';
export const GET_FILTERED_FAILURE = 'GET_FILTERED_FAILURE';

/**
 * Actions types for procesing crash categories data
 * Get all the categories availables to filter the data
 */
export const GET_CATEGORY_DATA_INIT = 'GET_CATEGORY_DATA_INIT';
export const GET_CATEGORY_DATA_SUCCESS = 'GET_CATEGORY_DATA_SUCCESS';
export const GET_CATEGORY_DATA_FAILURE = 'GET_CATEGORY_DATA_FAILURE';

/**
 * Actions types for procesing individual data of incidents
 * with his corresponding slider images
 * Severity, injuries, fatalities, date, etc.
 */
export const GET_INCIDENT_INFO_INIT = 'GET_INCIDENT_INFO_INIT';
export const GET_INCIDENT_INFO_SUCCESS = 'GET_INCIDENT_INFO_SUCCESS';
export const GET_INCIDENT_INFO_FAILURE = 'GET_INCIDENT_INFO_FAILURE';
